import React, { useState } from "react";

const SignalsPage = () => {
  const [signals, setSignals] = useState([
    {
      id: 1,
      pair: "XAUUSD",
      direction: "BUY",
      entry: "2350.20",
      sl: "2338.00",
      tp: "2378.00",
      status: "OPEN",
      issuedAt: "2026-01-18 09:32",
      analyst: "XAU Hybrid Desk",
      followingAnalyst: false,
    },
    {
      id: 2,
      pair: "EURUSD",
      direction: "SELL",
      entry: "1.0945",
      sl: "1.0990",
      tp: "1.0860",
      status: "CLOSED",
      issuedAt: "2026-01-18 07:10",
      analyst: "Macro Swing",
      followingAnalyst: false,
    },
    {
      id: 3,
      pair: "NAS100",
      direction: "BUY",
      entry: "18230",
      sl: "18050",
      tp: "18650",
      status: "OPEN",
      issuedAt: "2026-01-17 21:45",
      analyst: "Index Gamma",
      followingAnalyst: false,
    },
  ]);

  const [form, setForm] = useState({
    pair: "XAUUSD",
    direction: "BUY",
    entry: "",
    sl: "",
    tp: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateSignal = (e) => {
    e.preventDefault();
    if (!form.entry.trim() || !form.sl.trim() || !form.tp.trim()) return;

    const newId = signals.length
      ? Math.max(...signals.map((s) => s.id)) + 1
      : 1;

    const now = new Date();
    const issuedAt = now.toISOString().slice(0, 16).replace("T", " ");

    setSignals((prev) => [
      {
        id: newId,
        pair: form.pair.trim(),
        direction: form.direction,
        entry: form.entry.trim(),
        sl: form.sl.trim(),
        tp: form.tp.trim(),
        status: "OPEN",
        issuedAt,
        analyst: "You (dummy analyst)",
        followingAnalyst: false,
      },
      ...prev,
    ]);

    setForm({
      pair: "XAUUSD",
      direction: "BUY",
      entry: "",
      sl: "",
      tp: "",
    });
  };

  const toggleFollowAnalyst = (id) => {
    setSignals((prev) =>
      prev.map((s) =>
        s.id === id
          ? { ...s, followingAnalyst: !s.followingAnalyst }
          : s
      )
    );
  };

  const cancelSignal = (id) => {
    setSignals((prev) =>
      prev.map((s) =>
        s.id === id && s.status === "OPEN"
          ? { ...s, status: "CANCELLED_MANUAL" }
          : s
      )
    );
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h2>Signals</h2>
          <p className="muted">
            Dummy signal feed for role Analyst &amp; Investor. Analyst bisa
            membuat signal baru di sini (dummy), investor bisa follow analis.
            Timeframe tidak ditampilkan. Signal OPEN bisa di-cancel manual oleh
            analis. Nanti backend juga akan auto-cancel setelah 72 jam atau
            bila investor memilih cancel karena big news.
          </p>
        </div>
      </div>

      <div className="grid grid-2 dashboard-grid">
        {/* FORM CREATE SIGNAL */}
        <div className="card">
          <div className="card-title-row">
            <h3>Create signal (dummy form)</h3>
          </div>

          <form className="form-vertical" onSubmit={handleCreateSignal}>
            <label className="form-label">
              Symbol / Pair
              <input
                type="text"
                name="pair"
                className="form-input"
                value={form.pair}
                onChange={handleFormChange}
              />
            </label>

            <label className="form-label">
              Direction
              <select
                name="direction"
                className="form-input"
                value={form.direction}
                onChange={handleFormChange}
              >
                <option value="BUY">BUY</option>
                <option value="SELL">SELL</option>
              </select>
            </label>

            <label className="form-label">
              Entry
              <input
                type="text"
                name="entry"
                className="form-input"
                value={form.entry}
                onChange={handleFormChange}
                placeholder="e.g. 2350.20"
              />
            </label>

            <label className="form-label">
              Stop loss
              <input
                type="text"
                name="sl"
                className="form-input"
                value={form.sl}
                onChange={handleFormChange}
                placeholder="e.g. 2338.00"
              />
            </label>

            <label className="form-label">
              Take profit
              <input
                type="text"
                name="tp"
                className="form-input"
                value={form.tp}
                onChange={handleFormChange}
                placeholder="e.g. 2378.00"
              />
            </label>

            <button type="submit" className="btn-primary-sm">
              Publish signal (dummy)
            </button>
          </form>
        </div>

        {/* LIST SIGNAL */}
        <div className="card">
          <div className="card-title-row">
            <h3>Live &amp; recent signals</h3>
            <span className="badge-soft">Dummy data</span>
          </div>

          <table className="metrics-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Symbol</th>
                <th>Dir</th>
                <th>Entry</th>
                <th>SL</th>
                <th>TP</th>
                <th>Status</th>
                <th>Analyst</th>
                <th>Follow</th>
                <th>Cancel</th>
              </tr>
            </thead>
            <tbody>
              {signals.map((s) => (
                <tr key={s.id}>
                  <td>{s.id}</td>
                  <td>{s.pair}</td>
                  <td>{s.direction}</td>
                  <td>{s.entry}</td>
                  <td>{s.sl}</td>
                  <td>{s.tp}</td>
                  <td>{s.status}</td>
                  <td>{s.analyst}</td>
                  <td>
                    <button
                      type="button"
                      className={
                        s.followingAnalyst ? "btn-chip following" : "btn-chip"
                      }
                      onClick={() => toggleFollowAnalyst(s.id)}
                    >
                      {s.followingAnalyst ? "Following" : "Follow"}
                    </button>
                  </td>
                  <td>
                    {s.status === "OPEN" ? (
                      <button
                        type="button"
                        className="btn-chip danger"
                        onClick={() => cancelSignal(s.id)}
                      >
                        Cancel
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SignalsPage;
